export const Machine = {
  init: "machine/init",
  setState: "machine/setState",
  start: "machine/start",
  transition: "machine/transition",
};
